import { startCase } from 'lodash';

export const normalizeCommodity = (commodity: string) => startCase(commodity.replace(/_/g, ' '));
